function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import moment from 'moment';

import { RouterLink as Link } from '../';

var NavCalendarLink = function (_React$Component) {
    _inherits(NavCalendarLink, _React$Component);

    function NavCalendarLink() {
        _classCallCheck(this, NavCalendarLink);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    NavCalendarLink.prototype.render = function render() {
        var _props = this.props,
            root = _props.root,
            date = _props.date,
            datetime = _props.datetime,
            events = _props.events;


        var dateUrl = void 0;

        dateUrl = root + '/' + moment(datetime).format('YYYY/MM/DD');

        var selected = moment(datetime).isSame(date, 'day');
        var current = moment(datetime).isSame(date, 'month');

        var d = moment(datetime).format('D');

        var label = void 0;

        if (events && events.length) {
            label = React.createElement(
                'strong',
                null,
                d
            );
        } else {
            label = React.createElement(
                'span',
                null,
                d
            );
        }

        return React.createElement(
            Link,
            { url: dateUrl, className: 'nav-calendar__date', 'aria-current': current, 'aria-selected': selected, onClick: this.props.onClick },
            label
        );
    };

    return NavCalendarLink;
}(React.Component);

export default NavCalendarLink;